import { useState } from 'react';
import {
  IconBrandInstagram,
  IconRefresh,
  IconUnlink,
  IconPlayerPause,
  IconPlayerPlay,
} from '@tabler/icons-react';

import useInstagramAccount from '../hooks/useInstagramAccount';
import InstagramConnectFlow from '../../AgentsFlow/channels/plugins/Instagram/ConnectFlow';
import InstagramStatus from './InstagramStatus';

const InstagramPanel = ({ agentId }) => {
  const {
    account,
    loading,
    fetchStatus,
    togglePaused,
    refreshProfile,
    disconnect,
  } = useInstagramAccount(agentId);
  const [actionLoading, setActionLoading] = useState(false);

  const handleConnected = () => {
    fetchStatus();
  };

  const handleTogglePaused = async () => {
    if (!account) return;
    setActionLoading(true);
    try {
      await togglePaused(!account.bot_paused);
    } finally {
      setActionLoading(false);
    }
  };

  const handleRefresh = async () => {
    setActionLoading(true);
    try {
      await refreshProfile();
    } finally {
      setActionLoading(false);
    }
  };

  const handleDisconnect = async () => {
    if (!window.confirm('Tem certeza que deseja desconectar o Instagram?')) {
      return;
    }
    setActionLoading(true);
    try {
      await disconnect();
    } finally {
      setActionLoading(false);
    }
  };

  if (loading && !account) {
    return <div className="cloud-api-panel">Carregando...</div>;
  }

  // Sem conta conectada — exibe ConnectFlow OAuth inline.
  if (!account) {
    return (
      <InstagramConnectFlow
        agentId={agentId}
        onConnected={handleConnected}
        onCancel={() => {}}
      />
    );
  }

  return (
    <div className="cloud-api-panel">
      <div className="cloud-api-panel__header">
        <IconBrandInstagram size={24} />
        <h3>Instagram</h3>
      </div>

      <div
        className="cloud-api-profile"
        style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}
      >
        {account.profile_picture_url && (
          <img
            src={account.profile_picture_url}
            alt={account.username}
            style={{ width: 64, height: 64, borderRadius: '50%' }}
          />
        )}
        <div>
          <div style={{ fontWeight: 600, fontSize: 16 }}>@{account.username}</div>
          {account.display_name && (
            <div style={{ fontSize: 13, color: '#64748b' }}>
              {account.display_name}
            </div>
          )}
          <InstagramStatus account={account} />
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          gap: '0.5rem',
          marginTop: '1rem',
          flexWrap: 'wrap',
        }}
      >
        <button
          className="cloudapi-hero__action-btn"
          onClick={handleTogglePaused}
          disabled={actionLoading}
        >
          {account.bot_paused ? (
            <>
              <IconPlayerPlay size={16} />
              Reativar IA
            </>
          ) : (
            <>
              <IconPlayerPause size={16} />
              Pausar IA
            </>
          )}
        </button>
        <button
          className="cloudapi-hero__action-btn"
          onClick={handleRefresh}
          disabled={actionLoading}
        >
          <IconRefresh size={16} />
          Sincronizar dados
        </button>
        <button
          className="cloudapi-hero__action-btn cloudapi-hero__action-btn--danger"
          onClick={handleDisconnect}
          disabled={actionLoading}
        >
          <IconUnlink size={16} />
          Desconectar
        </button>
      </div>
    </div>
  );
};

export default InstagramPanel;
